import React from "react";
import BreadCrumbs, { PostBreadCrumbsLink } from "./BreadCrumb";

interface IPostBreadCrumbsProps extends React.PropsWithChildren {
  post: Queries.MicrocmsPost;
}

export default function PostBreadCrumbs(props: IPostBreadCrumbsProps) {
  const { post } = props;

  const links: PostBreadCrumbsLink[] = [
    {
      to: "/",
      content: "トップ",
    },
    {
      to: `/categories/${post.category?.id ?? ""}`,
      content: `#${post.category?.name ?? ""}`,
    },
    {
      content: post.title ?? "",
    },
  ];

  return <BreadCrumbs links={links} />;
}
